module.exports = __webpack_public_path__ + "static/media/rcn.a0e822ad.svg";